import React from "react";
import { Col } from "react-bootstrap";
import { FieldGroup } from "../Groups/FieldGroup";
import { RadioField } from "../Fields/RadioField";
import { Condition } from "../Conditionals/Condition";
import { FileField } from "../Fields/FileField";
import { InputField } from "../Fields/InputField";
import { TextareaField } from "../Fields/TextareaField";
import { pickOne, requiredField, requiredUpload } from "../Validation";
import TranslationWorkflow from "../../../Assets/Translation workflow.docx"
import PGQ76 from "../../../Assets/PGQ 76.docx"

export const TranslationForm = ( props ) => {
    return <>
        <Col md={ 12 }>
            <FieldGroup
                groupName="Translation Option"
                groupId="Translation"
                groupLabel={ "How will you manage creation of the " + props.elementType + "? (Please note: Translations are the responsibility of the local affiliate Unit and must follow the Translation Workflow Process)." }
                validator={ pickOne }
            >
                {/* OPTION prepared */ }
                <RadioField
                    fieldId="Translation Option"
                    fieldLabel={ "I will prepare the " + props.elementType + " in my language locally (Global Communications will send the original design files to you, waiting for the final draft to review before proceeding)." }
                    fieldValue="Prepared"
                >
                    <a href={TranslationWorkflow} target="_blank" download="Translation workflow.docx" rel="noopener noreferrer">Learn more about translation workflow.</a>
                    <a href={PGQ76} target="_blank" download="PGQ 76.docx" rel="noopener noreferrer">Download PGQ76</a>
                </RadioField>
                {/* OPTION needs help (opens file upload) */ }
                {
                    !props.elementType.includes("brochure") &&
                    !props.elementType.includes("advertisement") &&
                    !props.elementType.includes("roll up") &&
                    <RadioField
                        fieldId="Translation Option"
                        fieldLabel={ "I will need your support to prepare the " + props.elementType + " in my language (I will send the translated text following the PGQ76 Translation procedure)." }
                        fieldValue="Needs help"
                    />
                }
            </FieldGroup>
        </Col>
        <Condition when="Translation Option" is="Needs help">
            <Col md={ 12 }>
                <FileField
                    fileFieldId="translation_file"
                    fileFieldName="Translation File"
                    hint={ "If you need support preparing the document into your local language, please attach the approved translation (text file) of the " + props.elementType + " and the document PGQ76, signed." }
                    fileFieldLabel="File Upload"
                    fileFieldMultiple={ true }
                    validator={ requiredUpload }
                >
                    <p>
                        [<a className={ "link" } href={PGQ76} target="_blank" download="PGQ 76.docx" rel="noopener noreferrer">Click here to download the document PGQ76</a>]
                    </p>
                </FileField>
            </Col>
            <Col md={ 12 }>
                <InputField
                    fieldId="translationLanguage"
                    fieldLabel="Please indicate the language."
                    fieldType="text"
                    fieldRequired={ true }
                    validator={ requiredField }
                />
            </Col>
            <Col md={ 12 }>
                <TextareaField
                    fieldId="Translation"
                    fieldLabel="Description"
                    fieldRequired={ true }
                    validator={ requiredField }
                />
            </Col>
        </Condition>
    </>;
}